<div ui-row class="sp-m-24" [uiGutter]="[24, 48]">
  <div ui-col uiXs="8">
    <h4>Basic</h4>
    <ui-empty></ui-empty>
  </div>
  <div ui-col uiXs="8">
    <h4>Simple</h4>
    <ui-empty uiNotFoundImage="simple"></ui-empty>
  </div>

  <div ui-col uiXs="8">
    <h4>Customized</h4>
    <ui-empty uiNotFoundImage="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg" [uiNotFoundContent]="contentTpl" [uiNotFoundFooter]="footerTpl">
      <ng-template #contentTpl>
        <span>
          Customize
          <a href="#API">Description</a>
        </span>
      </ng-template>
      <ng-template #footerTpl>
        <button ui-button buttonType="primary">Create Now</button>
      </ng-template>
    </ui-empty>
  </div>
</div>
